import { MapContainer, TileLayer, useMap, Marker, Tooltip, LayersControl } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import styles from './css/map.module.css';
import './css/map.css';
import Point from "./point"
import React from 'react';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
   iconUrl: icon,
   shadowUrl: iconShadow,
   iconSize: [25, 41],
   iconAnchor: [12, 41],
   popupAnchor: [1, -34],
   tooltipAnchor: [16, -28],
   shadowSize: [41, 41],
});

const colorMarker = (color) => {
   var stylecolor = styles.lv0;
   if (color == 'lv1') stylecolor = styles.lv1;
   else if (color == 'lv2') stylecolor = styles.lv2;
   else if (color == 'lv3') stylecolor = styles.lv3;
   else if (color == 'lv4') stylecolor = styles.lv4;
   else if (color == 'lv5') stylecolor = styles.lv5;
   else if (color == 'rlv1') stylecolor = styles.rlv1;
   else if (color == 'rlv2') stylecolor = styles.rlv2;
   else if (color == 'rlv3') stylecolor = styles.rlv3;
   else if (color == 'rlv4') stylecolor = styles.rlv4;
   else if (color == 'rlv5') stylecolor = styles.rlv5;
   return L.icon({
      iconUrl: icon,
      shadowUrl: iconShadow,
      className: `default-marker ${stylecolor}`,
   });
};

function ChangeMapCenter({ position }) {
   const map = useMap()
   if (position == null) return
   map.panTo(position, { animate: true, duration: 1.0, easeLinearity: 0.1 })
   return null
}

export default function Map(props) {
   function selectMarker(e) {
      props.points.forEach(p => {
         if (p.latitude === e.latlng.lat && p.longitude === e.latlng.lng) props.onSelect(p.name);
      });
   }
   function leaveMarker(e) {
      props.onSelect("");
   }

   function openSite(e) {
      props.points.forEach(p => {
         if (p.latitude === e.latlng.lat && p.longitude === e.latlng.lng) props.onOpenSite({ menu: "site", site: p.name });
      });
   }

   function CustomTooltip(args) {
      if (args.point && args.point.name === args.p.name) {
         return <Tooltip className={styles.tooltip} direction="center" offset={[0, -140]} permanent={true} interactive={true} opacity={0.98}><Point point={args.p} /></Tooltip>
      } else {
         return <Tooltip className={styles.tooltip} direction="center" offset={[0, -140]} permanent={false} interactive={true} opacity={0.98}><Point point={args.p} /></Tooltip>
      }
   }

   if ( props.points.length == 0 ) return null;
   const bounds = L.latLngBounds(props.points.map(p => L.latLng(p.latitude, p.longitude)));

   return (
      <MapContainer bounds={bounds} boundsOptions={{padding: [50, 50]}} zoomControl={false}>
         <LayersControl position="bottomleft">
            <LayersControl.BaseLayer checked name="OpenStreetMap">
               <TileLayer
                  attribution='© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
               />
            </LayersControl.BaseLayer>
            {/*
         <LayersControl.BaseLayer name="国土地理院">
            <TileLayer
               attribution="<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>国土地理院</a>"
               url="https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png"
            />
         </LayersControl.BaseLayer>
         <LayersControl.BaseLayer name="Google Map">
            <TileLayer
               attribution='&copy; <a href="https://developers.google.com/maps/documentation">Google Map</a>'
               url="https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}"
            />
         </LayersControl.BaseLayer>
         <LayersControl.BaseLayer name="航空写真">
            <TileLayer
               attribution="Tiles © Esri — Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
               url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            />
         </LayersControl.BaseLayer>
   */}

         </LayersControl>
         {
            props.points.map((p, idx) => (
               <Marker key={idx} position={[p.latitude, p.longitude]} icon={colorMarker(p.selected.markerColor)} eventHandlers={{ click: openSite, mouseover: selectMarker, mouseout: leaveMarker }} >
                  <CustomTooltip point={props.point} p={p} />
               </Marker>
            ))
         }
         <ChangeMapCenter position={props.position} />
      </MapContainer>
   )
};